<template>
  <div class="mk-subject-right-block-fixed">
    <div class="inner-box">
      <div v-if="childItem.propsValue.data.customField1.customField11">
        <img :src="childItem.propsValue.data.customField1.customField14" />
        <p>发送邮件</p>
      </div>
      <div v-if="childItem.propsValue.data.customField2.customField21">
        <img :src="childItem.propsValue.data.customField2.customField24" />
        <p>电话沟通</p>
      </div>
      <div v-if="childItem.propsValue.data.customField3.customField31">
        <img :src="childItem.propsValue.data.customField3.customField34" />
        <p>在线咨询</p>
      </div>
      <div v-if="childItem.propsValue.data.customField4.customField41">
        <img :src="childItem.propsValue.data.customField4.customField44" />
        <p>扫码咨询</p>
      </div>
      <div v-if="childItem.propsValue.data.customField5.customField51">
        <img :src="childItem.propsValue.data.customField5.customField54" />
        <p>获取方案</p>
      </div>
    </div>
</div>
</template>

<script>
export default {
  name: "MkSemBlockWeb",
  props: {
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "邮件",
          type: "object",
          keys: [
            {
              code: "customField11",
              label: "显示",
              type: "radio",
              data: [
                { label: "是", value: true },
                { label: "否", value: false }
              ]
            },
            {
              code: "customField12",
              label: "标题",
              type: "text"
            },
            {
              code: "customField13",
              label: "邮件",
              type: "text"
            }
          ]
        },
        {
          code: "customField2",
          label: "电话",
          type: "object",
          keys: [
            {
              code: "customField21",
              label: "显示",
              type: "radio",
              data: [
                { label: "是", value: true },
                { label: "否", value: false }
              ]
            },
            {
              code: "customField22",
              label: "标题",
              type: "text"
            },
            {
              code: "customField23",
              label: "电话",
              type: "text"
            }
          ]
        },
        {
          code: "customField3",
          label: "在线咨询",
          type: "object",
          keys: [
            {
              code: "customField31",
              label: "显示",
              type: "radio",
              data: [
                { label: "是", value: true },
                { label: "否", value: false }
              ]
            },
            {
              code: "customField32",
              label: "标题",
              type: "text"
            }
            // {
            //   code: "customField33",
            //   label: "咨询方式",
            //   type: "text"
            // }
          ]
        },
        {
          code: "customField4",
          label: "扫码咨询",
          type: "object",
          keys: [
            {
              code: "customField41",
              label: "显示",
              type: "radio",
              data: [
                { label: "是", value: true },
                { label: "否", value: false }
              ]
            },
            {
              code: "customField42",
              label: "标题",
              type: "text"
            },
            {
              code: "customField43",
              label: "二维码",
              type: "image",
              width: 200,
              height: 260,
            }
          ]
        },
        {
          code: "customField5",
          label: "获取方案",
          type: "object",
          keys: [
            {
              code: "customField51",
              label: "显示",
              type: "radio",
              data: [
                { label: "是", value: true },
                { label: "否", value: false }
              ]
            },
            {
              code: "customField52",
              label: "标题",
              type: "text"
            },
            {
              code: "customField53",
              label: "表单",
              type: "form"
            }
          ]
        }
      ],
      data: {
        customField1: {
          customField11: true,
          customField12: "发送邮件",
          customField13: "",
          customField14: "https://mks.yybip.com/group1/M00/09/32/CgoRC2O_1L6AaZ3DAAAEYvkmua8717.png",
          customField15: 'https://mks.yybip.com/group1/M00/01/82/CgoRDGO_1RuAJRkqAAAEgguGdX0947.png'
        },
        customField2: {
          customField21: true,
          customField22: "电话沟通",
          customField23: "4006-600-577",
          customField24: "https://mks.yybip.com/group1/M00/09/32/CgoRC2O_1R6ABVwXAAAHDNt_vw0299.png",
          customField25: 'https://mks.yybip.com/group1/M00/01/83/CgoRDGO_1UKAY_qVAAAHK6cR30I976.png'
        },
        customField3: {
          customField31: true,
          customField32: "在线咨询",
          customField33: "",
          customField34: "https://mks.yybip.com/group1/M00/09/32/CgoRC2O_1UiAMhXHAAAGPOqW1fQ539.png",
          customField35: 'https://mks.yybip.com/group1/M00/01/83/CgoRDGO_1XyAYUOiAAAGa0C8ASc164.png'
        },
        customField4: {
          customField41: true,
          customField42: "扫码咨询",
          customField43: "https://mks.yybip.com/group1/M00/09/41/CgoRC2PvLFqAe0txAAEmWe9W5YQ117.jpg",
          customField44: "https://mks.yybip.com/group1/M00/09/32/CgoRC2O_1YSASl0eAAADZ3_nSJg473.png",
          customField45: 'https://mks.yybip.com/group1/M00/01/83/CgoRDGO_1aCANforAAADVgzJiJo550.png'
        },
        customField5: {
          customField51: true,
          customField52: "获取方案",
          customField53: "",
          customField54: "https://mks.yybip.com/group1/M00/09/32/CgoRC2O_1amAIiR0AAADmo7Ej34772.png",
          customField55: 'https://mks.yybip.com/group1/M00/01/83/CgoRDGO_1ciANF9UAAADjVqwEDs682.png'
        }
      }
    };
  }
};
</script>


<style lang="scss">
.mk-subject-right-block-fixed {
  position: absolute;
  bottom: 30px;
  right: 10px;
  width: 70px;
  z-index: 10;
  height: 220px;
}
.mk-subject-right-block-fixed .inner-box {
  position: relative;
  width: 70px;
  height: auto;
  margin-bottom: 10px;
  box-sizing: border-box;
  padding: 8px;
  background: #e60012;
  border-radius: 6px;
  display: block;
  text-align: center;
  >div {
    padding: 4px 0;
    border-bottom: #ededec 1px solid;
  }
  >div:last-child {
    padding: 4px 0;
    border-bottom: none;
  }
}
.mk-subject-right-block-fixed .inner-box > div > img {
  width: 28px;
  display: inline-block;
}
.mk-subject-right-block-fixed .inner-box p {
  font-size: 12px;
  color: rgb(255, 255, 255);
  opacity: 0.8;
}

.mk-subject-right-block-fixed .outer-box {
  display: none;
  position: absolute;
  width: 160px;
  right: 90px;
  top: 0px;
  border-radius: 6px;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.12);
}

.mk-subject-right-block-fixed .outer-box-con {
  padding: 12px 16px 5px 16px;
  position: relative;
  background: #fff;
  border: 1px solid #f8f8f8;
  border-radius: 6px;
  text-align: left;
}
.mk-subject-right-block-fixed .outer-box-con p {
  font-size: 14px;
  font-weight: 400;
  height: 20px;
  line-height: 20px;
  color: #666666;
  border-radius: 6px;
  margin-bottom: 4px;
}
.mk-subject-right-block-fixed .outer-dot {
  position: absolute;
  right: -15px;
  top: 15%;
  background: url(https://www.yonyou.com/sem/images/dot_04.png) no-repeat center
    center;
  width: 22px;
  height: 22px;
}
</style>
